import React, { PureComponent, Fragment } from "react";
import Icofont from 'react-icofont';
import { Link } from "react-scroll";
import { PAYMENT_TAB } from "../../constants/Payment";

class PricingItem extends PureComponent {

    itemonesData = [
        {
            planName: "",
            className: "plan",
            description: "",
            FeaturedClass: "",
            Featured: "",
            price: "單次贊助",
            content1: "自由決定金額",
            content2: "",
            content3: "可選擇以Stripe/Paypal網上付款、FPS、Payme、銀行轉賬或支票形式支持我們",
            content4: "",
            BtnName: "立即贊助",
            btnOnClick: () => this.props.changeTab(PAYMENT_TAB.ONCE)
        },
        {
            planName: "尊貴月費會員",
            className: "plan featured",
            description: "每月",
            FeaturedClass: "listing-badges",
            Featured: "推薦",
            price: <Fragment>$400<sup>#</sup></Fragment>,
            content1: "收到高登最新推廣產品",
            content2: "",
            content3: "優先獲邀請出席高登討論區活動包括研討會﹑講座﹑論壇等",
            content4: "",
            content5: "收到高登新聞台出版的電子年報",
            content6: "",
            content7: "高登會員（需提供論壇會員ID）將不定時獲派膠幣",
            content8: "",
            content9: "可選擇以Stripe/Paypal網上付款訂閱支持我們",
            BtnName: "立即贊助",
            btnOnClick: () => this.props.changeTab(PAYMENT_TAB.MONTHLY)
        },
        {
            planName: "普通月費會員",
            className: "plan",
            description: "每月",
            FeaturedClass: "",
            Featured: "",
            price: "$200",
            content1: "收到高登最新推廣產品相關資訊",
            content2: "",
            content3: "可申請出席高登討論區活動包括研討會﹑講座﹑論壇等",
            content4: "",
            content5: "可選擇以Stripe/Paypal網上付款訂閱支持我們",
            BtnName: "立即贊助",
            btnOnClick: () => this.props.changeTab(PAYMENT_TAB.MONTHLY)
        },
    ]

    render() {
        //Start ItemOne Loop
        const itemonedata = this.itemonesData.map((itemone, index) => (

            <div className={itemone.className} key={index}>
                <div className={itemone.FeaturedClass}>
                    <span className="featured">{itemone.Featured}</span>
                </div>
                <div className="plan-price">
                    <h3>{itemone.planName}</h3>
                    <span className="value">{itemone.price}</span>
                    <span className="period">{itemone.description}</span>
                </div>

                <div className="plan-features">
                    <ul>
                        <li>{itemone.content1}</li>
                        <li>{itemone.content2}</li>
                        <li>{itemone.content3}</li>
                        <li>{itemone.content4}</li>
                        <li>{itemone.content5}</li>
                        <li>{itemone.content6}</li>
                        <li>{itemone.content7}</li>
                        <li>{itemone.content8}</li>
                        <li>{itemone.content9}</li>
                    </ul>
                    <div className="center-wrap">
                        <Link
                            activeclass="active"
                            to="payment"
                            spy={true}
                            smooth={true}
                            offset={-50}
                            duration={800}
                            className="btn-a"
                        >
                            <div className="button" onClick={itemone.btnOnClick}>
                                {itemone.BtnName}
                                <Icofont icon="icofont-arrow-right" />
                                <div className="mask" /></div>
                        </Link>
                    </div>
                </div>
            </div>

        ));
        //End ItemOne Loop
        return (
            <React.Fragment>
                <div role="tabpanel" className="tab-pane fade show active" id="monthly">
                    <div className="pricing-container margin-top-60">
                        {itemonedata}
                    </div>
                    <p>#會員可按意願選擇支付多於$400的月費作為對我們額外的支持。</p>
                </div>
            </React.Fragment>
        );
    }
}

export default PricingItem;
